export default __webpack_public_path__ + "static/media/Logo_Dark.b178d944.svg";